export enum ERouteName {
  HOME = 'home',
  LICENSE = 'license',
  PRICE_CALCULATOR_SETTINGS = 'settings',
  LOGIN = 'login',
  COMPANIES = 'companies',
  COMPANIES_CREATE = 'companies-create',
  COMPANIES_DETAIL = 'companies-detail',
  PROJECTS_DETAIL = 'projects-detail',
}
